import { useCallback, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { ordersActions } from './actions'
import {
  selectOrders,
  selectOrdersFilters,
  selectOrdersPagination,
  selectOrdersLoading,
  selectOrdersError,
  selectOrderById,
  selectOrderLoading,
  selectOrderError
} from './selectors'

/**
 * Hook para gerenciar pedidos do usuário
 * Compatível com useOrders antigo
 */
export const useOrders = (params?: { status?: string; page?: number; limit?: number }) => {
  const dispatch = useAppDispatch()
  const orders = useAppSelector(selectOrders)
  const filters = useAppSelector(selectOrdersFilters)
  const pagination = useAppSelector(selectOrdersPagination)
  const loading = useAppSelector(selectOrdersLoading)
  const error = useAppSelector(selectOrdersError)

  // Carregar pedidos quando params mudarem
  useEffect(() => {
    const currentParams = params ? { ...filters, ...params } : filters
    dispatch(ordersActions.fetchOrdersRequest(currentParams))
  }, [JSON.stringify(params)])

  const reload = useCallback(() => {
    const currentParams = params ? { ...filters, ...params } : filters
    dispatch(ordersActions.fetchOrdersRequest(currentParams))
  }, [dispatch, filters, params])

  return {
    orders,
    loading,
    error,
    pagination,
    reload
  }
}

/**
 * Hook para obter detalhes de um pedido específico
 * Compatível com useOrder antigo
 */
export const useOrder = (orderId?: string) => {
  const dispatch = useAppDispatch()
  const order = useAppSelector((state) => {
    if (orderId) return selectOrderById(orderId)(state)
    return null
  })
  const loading = useAppSelector(selectOrderLoading)
  const error = useAppSelector(selectOrderError)

  useEffect(() => {
    if (orderId) {
      dispatch(ordersActions.fetchOrderRequest(orderId))
    }
  }, [dispatch, orderId])

  return { order, loading, error }
}

